import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Categorias from "../components/Categorias";
import CampoBusca from "../components/CampoBusca";
import { useFiltro } from "../context/FiltroContext";

// Busca do cardápio sempre visível na faixa da marca (antes ficava escondida na lupa do header).
// Fica fora do Categorias para não perder o foco quando a lista recarrega.
const BuscaCardapio = () => {
  const { id } = useParams();
  const { setNomeBuscaProduto } = useFiltro();
  const [termo, setTermo] = useState("");

  // Ao trocar de restaurante, começa sem busca.
  useEffect(() => {
    setTermo("");
    setNomeBuscaProduto("");
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  // O cardápio inteiro já está na tela, então a busca filtra na hora (sem mínimo de letras).
  useEffect(() => {
    const timer = setTimeout(() => setNomeBuscaProduto(termo.trim()), 150);
    return () => clearTimeout(timer);
  }, [termo]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className="cardapio-faixa">
      <CampoBusca
        valor={termo}
        onChange={setTermo}
        placeholder="Buscar no cardápio"
      />
    </section>
  );
};

const Home = () => {
  return (
    <div className="home">
      <BuscaCardapio />
      <Categorias />
    </div>
  );
};

export default Home;
